import React from 'react';
import G from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";
import "./IntervalTypeField.css";

const prefix = 'IntervalTypeField';

const IntervalTypeField = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			values: props.values ?? appLib.intervalValues(),
			value: props.value || ( props.default ?? ( props.root ? 5 : false))
		};
		if ( props.root ) {
			this.state.values = this.state.values.filter( x => !! x.value );
		}
		this.uid = G.generateUid(prefix);
		this.setValue = this.setValue.bind(this);
	}
	setValue(x) {
		this.setState({value: x}, ()=> {
			this.props.onChange(x);
		})
	}
	render() {
		return (
			<div className={prefix} id={this.uid}>
				{ this.state.values.map( (v,i)=> (
					<span
						key={i}
						className={ this.state.value === v.value ? 'checked' : 'unchecked' }
						onClick={() => this.setValue(v.value)}
					>
							{ v.label }
					</span>
				))}
			</div>
		)
	}
}
export default IntervalTypeField;
